import React from 'react';

const Tab = (props) => {
    return (
        <li className="nav-item label-oscura"> 
            <a 
                className={props.isActive ? "nav-link active" : "nav-link"} 
                data-toggle="tab" 
                role="tab" 
                aria-selected="false"
            >
                <span className="hidden-sm-up">
                    <i className={props.icon}/>
                </span> 

                <span className="hidden-xs-down">
                    {props.name}
                </span>
            </a>
        </li>
    );
}

export default Tab;